import Layout from '@/layout/layout'

const elementRouter = {
  path: '/merchant',
  component: Layout,
  redirect: 'noRedirect',
  name: '第三方回收商',
  children: [
    {
      path: 'list',
      component: () => import('@/views/merchant/views/list/index'),
      name: '商家列表',
      meta: { title: '商家列表', noCache: true }
    },
    {
      path: 'add',
      component: () => import('@/views/merchant/views/add/index'),
      name: '添加商家',
      meta: { title: '添加商家', noCache: true }
    },
    {
      path: 'apply',
      component: () => import('@/views/merchant/views/apply/index'),
      name: '入驻申请',
      meta: { title: '入驻申请', noCache: true }
    },
    {
      path: 'queryDetails',
      component: () => import('@/views/merchant/views/queryDetails/index'),
      name: '串号查询明细',
      meta: { title: '串号查询明细', noCache: true }
    },
    {
      path: 'reviewSettings',
      component: () => import('@/views/merchant/views/reviewSettings/index'),
      name: '审单报价设置',
      meta: { title: '审单报价设置', noCache: true }
    },
    {
      path: 'examineStatistics',
      component: () => import('@/views/merchant/examineStatistics/index'),
      name: '审单数据',
      meta: { title: '审单数据', noCache: true }
    },
    {
      path: 'quickData',
      component: () => import('@/views/merchant/quickData/index'),
      name: '快捷报价数据',
      meta: { title: '快捷报价数据', noCache: true }
    },
    {
      path: 'referencePriceManage',
      component: () => import('@/views/merchant/referencePriceManage/index'),
      name: '参考价管理',
      meta: { title: '参考价管理', noCache: true }
    },
    {
      path: 'aiReadPictures',
      component: () => import('@/views/merchant/aiReadPictures/index'),
      name: 'AI识图',
      meta: { title: 'AI识图', noCache: true }
    },
    {
      path: 'checkPage',
      component: () => import('@/views/merchant/aiReadPictures/view/checkPage'),
      name: 'AI识图核对',
      meta: { title: 'AI识图核对', noCache: true }
    },
    {
      path: 'aiReview',
      component: () => import('@/views/merchant/aiReview/index'),
      name: '识图复核',
      meta: { title: '识图复核', noCache: true }
    },
    {
      path: 'reviewPage',
      component: () => import('@/views/merchant/aiReview/view/reviewPage'),
      name: '识图复核',
      meta: { title: '识图复核', noCache: true }
    },
     {path: 'rule',
      component: () => import('@/views/merchant/rule/index'),
      name: '回收商规则设置',
      meta: { title: '回收商规则设置', noCache: true }
    },
    {path: 'imgLab',
      component: () => import('@/views/merchant/imgLab/index'),
      name: 'AI识图标签',
      meta: { title: 'AI识图标签', noCache: true }
    },
    {path: 'automaticQuotationMerchants',
      component: () => import('@/views/merchant/automaticQuotationMerchants/index'),
      name: '自动报价商家配置',
      meta: { title: '自动报价商家配置', noCache: true }
    },
  ]
}

export default elementRouter
